import { api } from "../../../api/api";
import { getFileExtensionFromUrl } from "./getFileNameFromUrl";

const getMimeType = (fileName: string): string => {
  const ext = getFileExtensionFromUrl(fileName).toLowerCase();
  switch (ext) {
    case "png":
      return "image/png";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "pdf":
      return "application/pdf";
    case "json":
      return "application/json";
    case "txt":
      return "text/plain";
    default:
      return "application/" + ext;
  }
};

export const previewFile = async (fileName: string | null) => {
  if (fileName) {
    if (fileName.startsWith("http://") || fileName.startsWith("https://") || fileName.startsWith("blob:")) {
      window.open(fileName, "_blank");
      return null;
    }
    const res = await api.post(
      "/general/download-files",
      {
        type: "",
        keys: [fileName],
      },
      {
        responseType: "arraybuffer",
      },
    );

    const mimeType = getMimeType(fileName);
    const blob = new Blob([res.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
  }
  return null;
};

export const openFileInNewTab = async (
  file?: File | null,
  fileUrl?: string | null,
) => {
  try {
    // Case 1: Local file
    if (file) {
      const url = URL.createObjectURL(file);
      window.open(url, "_blank");
      return;
    }

    // Case 2: File URL
    if (fileUrl) {
      const res = await api.post(
        "/general/download-files",
        {
          type: "",
          keys: [fileUrl],
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([res.data]);
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank");
    }
  } catch (err) {
    console.error("File preview error:", err);
    throw err;
  }
};
